import { Tooltip } from 'antd';
import InlineModal from '../../shared/InlineModal';
import SectionCompetitorResults from '../../shared/SectionCompetitorResults';
import SectionMessage from '../../shared/SectionMessage';
import SectionTitle from '../../shared/SectionTitle';
import SectionTooltip from '../../shared/SectionTooltip';
import { SectionProps } from '../../types';
import './SpellCheckerSection.less';
import React from 'react';

export default function SpellCheckerSection({ sectionKey, title, url, relevance, tooltip, result, competitorsResults, passRate }: SectionProps) {
    const hasCompetitors = competitorsResults && Object.keys(competitorsResults).length > 0;

    return (
        <div
            id={sectionKey}
            className={`report-element ${result.status}`}
        >
            <SectionTitle title={title} />

            <div className="report-element-description">
                <SectionMessage
                    url={url}
                    status={result.status}
                    relevance={relevance}
                    message={result.message}
                    hasCompetitors={hasCompetitors}
                />

                {result.spelling_issues && <SpellCheckerResult spellingIssues={result.spelling_issues} />}

                {hasCompetitors && (
                    <SectionCompetitorResults
                        results={competitorsResults}
                        relevance={relevance}
                    />
                )}
            </div>

            <SectionTooltip tooltip={tooltip} />
        </div>
    );
}

type SpellCheckerResultProps = {
    spellingIssues: {
        context: string;
        tokens: {
            token: string;
            type: string;
            label: string;
            offset: number;
            suggestions: {
                score: number;
                suggestion: string;
            }[];
        }[];
    }[];
};

function SpellCheckerResult({ spellingIssues }: SpellCheckerResultProps) {
    return (
        <div className="description-meta">
            <InlineModal
                openLabel="See results list"
                modalTitle="Full list of spelling issues"
                closeLabel="Close"
            >
                <ul>
                    {spellingIssues.map((issue, index) => {
                        let lastTokenEndPosition = 0;
                        let currentTokenEndPosition = 0;
                        let typoNo = 0;

                        return (
                            <li key={index}>
                                {issue.tokens.map((typo, index) => {
                                    typoNo += 1;

                                    lastTokenEndPosition = currentTokenEndPosition;
                                    currentTokenEndPosition = typo.offset + typo.token.length;

                                    const contextBeforeToken = issue.context.substring(lastTokenEndPosition, typo.offset);
                                    const contextAfterToken = issue.context.substring(currentTokenEndPosition);

                                    return (
                                        <React.Fragment key={index}>
                                            <span>{contextBeforeToken}</span>
                                            <Tooltip
                                                title={
                                                    <div>
                                                        {typo.suggestions.map((typoSuggestion, idx) => (
                                                            <p key={idx}>{typoSuggestion.suggestion}</p>
                                                        ))}
                                                    </div>
                                                }
                                            >
                                                <span className={`misspelled ${typo.label === 'hard' ? 'hard' : 'soft'}`}>{typo.token}</span>
                                            </Tooltip>
                                            {typoNo === issue.tokens.length && <span>{contextAfterToken}</span>}
                                        </React.Fragment>
                                    );
                                })}
                            </li>
                        );
                    })}
                </ul>
            </InlineModal>
        </div>
    );
}
